import { Button, Dialog } from "@mui/material";
import React, { useRef, useState } from "react";
import { FiUpload } from "react-icons/fi";
import useUploadProductFile from "../../../hooks/product/useUploadProductFile";
import AsyncSelect from "../inputs/AsyncSelect";
import toast from "react-hot-toast";

const ProductExcelUploadModal = ({ isOpen, handleClose }) => {
  const {
    brandOptions,
    brandHasMore,
    fetchBrands,
    brandQuery,
    brandId,
    handleBrandSelect,
    uploadProductFile,
    downloadTemplate,
  } = useUploadProductFile({
    onClose: handleClose,
  });

  const uploadNormalRef = useRef(null);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [fileName, setFileName] = useState("");
  const [currentUploadId, setCurrentUploadId] = useState("");

  // Get user role from sessionStorage
  const userRole = sessionStorage.getItem("roles");
  const isAdmin = userRole === "admin";

  const handleFileChange = (e, uploadId) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setFileToUpload(file);
      setCurrentUploadId(uploadId);
    } else {
      setFileName("");
      setFileToUpload(null);
    }
  };

  const handleUploadFile = () => {
    if (!isAdmin && !brandId) {
      toast.error("Please select a brand");
      return;
    }
    if (!fileToUpload) {
      toast.error("Please select a file to upload");
      return;
    }
    uploadProductFile(fileToUpload, brandId);
  };

  const handleDownloadTemplate = () => {
    downloadTemplate(brandId);
  };

  return (
    <Dialog maxWidth={"sm"} fullWidth open={isOpen} onClose={handleClose}>
      <div className="p-5">
        <h1 className="text-lg font-semibold">Upload Products Excel</h1>

        <div className="flex justify-end">
          <button
            className="underline underline-offset-1"
            onClick={handleDownloadTemplate}
          >
            Download template
          </button>
        </div>

        <div>
          <label className="mb-2 block text-sm mt-5">
            Select Brand:{!isAdmin && <span className="text-red-500">*</span>}
          </label>
          <AsyncSelect
            options={brandOptions}
            hasMore={brandHasMore}
            fetchNext={fetchBrands}
            isLoading={brandQuery?.isFetching}
            value={brandId}
            onChange={handleBrandSelect}
          />
        </div>

        <button
          className="flex gap-2 items-center mt-5 underline underline-offset-2"
          type="submit"
          onClick={() => uploadNormalRef.current.click()}
        >
          <FiUpload />
          Select File
        </button>
        <input
          ref={uploadNormalRef}
          onChange={(e) => handleFileChange(e, null)}
          type="file"
          accept=".xls, .xlsx"
          id="fileInput"
          className="hidden"
        />
        {fileName && <p className="mt-5">{fileName}</p>}

        <div className="grid place-items-center mt-5">
          <Button
            variant="contained"
            className={" primaryBtn-solid"}
            onClick={handleUploadFile}
          >
            Upload File
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ProductExcelUploadModal;
